import { AbroadPostings } from './AbroadPostings';
import { AttachmentPostings } from './AttachmentPostings';
import { ContractualPostings } from './ContractualPostings';
import { DeputationPostings } from './DeputationPostings';
import { PostingRecordPostings } from './PostingRecordPostings';
import { ForeignTravelPostings } from './ForeignTravelPostings';

export {
  AbroadPostings,
  AttachmentPostings,
  ContractualPostings,
  DeputationPostings,
  PostingRecordPostings,
  ForeignTravelPostings,
};
